const faArrowsRepeat = {
  prefix: 'fal',
  iconName: 'arrows-repeat',
  icon: [
    512,
    512,
    ['repeat-alt'],
    'f364',
    'M475.3 107.3c6.2-6.2 6.2-16.4 0-22.6l-96-96c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L425.4 80 192 80C86 80 0 166 0 272 0 280.8 7.2 288 16 288s16-7.2 16-16c0-88.4 71.6-160 160-160l233.4 0-68.7 68.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l96-96zM36.7 404.7c-6.2 6.2-6.2 16.4 0 22.6l96 96c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L86.6 432 320 432c106 0 192-86 192-192 0-8.8-7.2-16-16-16s-16 7.2-16 16c0 88.4-71.6 160-160 160l-233.4 0 68.7-68.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-96 96z',
  ],
};
export default faArrowsRepeat;
